import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';
import { HomePageData } from '@/types/Home';
import getSubFromToken from '@/utils/getSubFromToken';

const AUCTION_CALENDAR_RANKING_VERSION = 'alv_ranking';
const TRENDING_RANKING_VERSION_ML = 'ml_predictions';

/**
 * @category Item API
 * @see getHomeData
 */
type GetHomeDataParams = {
    authToken: string;
    deployment: string;
    forceUpdate: boolean;
    shouldUseAverageLotValueActionCalendarRanking?: boolean;
};
type GetHomeDataResponse = {
    data: HomePageData;
    message: string;
    success: boolean;
};

/**
 * Gets Home page data via GET request to Item API
 * @function getHomeData
 * @category Item API
 * @param {GetHomeDataParams}
 * @returns {GetHomeDataResponse}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spapage/home
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/react-site/routes/get-spa-home-page.ts
 */
export const getHomeData = ({
    authToken,
    deployment,
    forceUpdate,
    shouldUseAverageLotValueActionCalendarRanking,
}: GetHomeDataParams) =>
    new Promise<GetHomeDataResponse>((resolve, reject) => {
        const bidderId = getSubFromToken(authToken);
        let request: ReturnType<typeof makeGet>;
        const query: Record<string, string | number> = {};
        if (bidderId) {
            request = makeGet({
                apiPath: 'spapage/home/new',
                authToken,
                deployment,
                path: ApiHosts.ItemApi,
            });
            query.bidderId = bidderId;
        } else {
            request = makeGet({
                apiPath: 'spapage/home/new',
                deployment,
                path: ApiHosts.ItemApi,
            });
        }
        query.trendingLimit = 20;
        query.offset = new Date().getTimezoneOffset();
        query.trendingRankingVersion = TRENDING_RANKING_VERSION_ML;
        if (shouldUseAverageLotValueActionCalendarRanking) {
            query.auctionCalendarRankingVersion = AUCTION_CALENDAR_RANKING_VERSION;
        }

        if (forceUpdate) {
            query.bustLocalCache = Date.now();
        }
        request.query(query);
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
